import { Directive, RendererStyleFlags2 } from '@angular/core';
import { Model } from '@df/catalog/model';
import { Swiper } from 'swiper';
import { SwiperEvents } from 'swiper/types';
import { LocalModelCarouselComponent } from '../local-model-carousel/local-model-carousel.component';
import { ICustomCategoryItem } from '../local-model-carousel/local-model-carousel.interface';
import { EModelCarouselVariant } from '../model-carousel/model-carousel.interface';
import { ILocalModelCarouselV2Data } from './local-model-carousel-v2.interface';

let uid = 0;

@Directive()
export abstract class LocalModelCarouselV2Component<
    T extends Model,
    D extends ILocalModelCarouselV2Data = ILocalModelCarouselV2Data
> extends LocalModelCarouselComponent<T, D> {
    override readonly uid = uid++;

    override items:
        | {
              id: string | number;
              model: T & D;
              modelView?: boolean;
              altView?: boolean;
          }[]
        | any[] = [];

    override touchMoveHandle(eventParams: Parameters<SwiperEvents['touchMove']>) {
        const [swiper] = eventParams;

        super.touchMoveHandle(eventParams);

        this.renderer.setStyle(
            this.elementRef.nativeElement,
            '--carousel-translate',
            (<Swiper>swiper).translate,
            RendererStyleFlags2.DashCase
        );
    }

    override activeIndexChangeHandle(eventParams: Parameters<SwiperEvents['activeIndexChange']>) {
        const [swiper] = eventParams;

        this.renderer.setStyle(
            this.elementRef.nativeElement,
            '--carousel-translate',
            (<Swiper>swiper).translate,
            RendererStyleFlags2.DashCase
        );

        super.activeIndexChangeHandle(eventParams);
    }

    protected override onModelsSet(): void {
        super.onModelsSet();

        if (this.component?.variant === EModelCarouselVariant.CustomElements) {
            this.items = (this.component.custom_items as ICustomCategoryItem[]);
            this.type = 'custom';
        }
    }
}
